import IUserSettings from '@/models/IUserSettings';
import WebEnvConfig from '@/models/WebEnvConfig';
import ServiceHelperFactory from './ServiceHelperFactory';
import BaseApiService from '../BaseApiService';
import IServiceHelper from '../IServiceHelper';

export default class SettingsService extends BaseApiService {
    constructor(webEnvConfig: WebEnvConfig) {
        super(webEnvConfig.urls?.quickSourceApi ?? '');
    }

    getServiceHelper(): IServiceHelper {
        return ServiceHelperFactory.getHelper();
    }

    async getUserSettings(): Promise<IUserSettings> {
        this.addAcceptJsonHeader();

        const response = await this.axiosInstance.get('/v5/settings');
        if (response.data) {
            return response.data as IUserSettings;
        }

        return response.data;
    }

    async saveUserSettings(payload: any) {
        this.addContentTypeJsonHeader();
        const data = JSON.stringify(payload);
        const response = await this.axiosInstance.patch('/v5/settings', data);
        return response;
    }

    async useUserSettings(payload: any) {
        this.addContentTypeJsonHeader();
        const data = JSON.stringify(payload);
        const response = await this.axiosInstance.post('/v5/settings/use-user-settings', data);
        return response;
    }
}
